"use client";

import type { ReactNode } from "react";
import { track } from "@/lib/analytics";

// Anchor that fires a PostHog event before navigating. Used for pricing CTAs and the
// sample-report link so the new journey is measurable. Same-page (#signup) and
// cross-page (/#signup) hrefs both work with a plain anchor.
export function TrackedLink({
  href,
  event,
  props = {},
  className = "",
  newTab = false,
  children,
}: {
  href: string;
  event: string;
  props?: Record<string, unknown>;
  className?: string;
  newTab?: boolean;
  children: ReactNode;
}) {
  return (
    <a
      href={href}
      className={className}
      onClick={() => track(event, props)}
      {...(newTab ? { target: "_blank", rel: "noopener" } : {})}
    >
      {children}
    </a>
  );
}
